import Schema from '../Schema';

import { PAYMENT_METHOD, PAYMENT_METHOD_PATTERN } from '../../constants/shop';

const CARD_BRANDS = {
  VISA: 'Visa',
  AMEX: 'American Express',
  MASTER: 'MasterCard',
  DISCOVER: 'Discover',
  JCB: 'JCB',
  DINERS: 'Diners Club'
};

/*
決済情報
*/
export const Payment = new Schema({
  _id: String,
  // Payment method
  method: {
    type: String,
    enum: PAYMENT_METHOD_PATTERN
  },

  stripe: {
    // Stripe customer id (ex: cus_3bi7R7XCE2GkIn )
    customer_id: {
      type: String,
      default: ''
    },
    // Stripe card id (ex: card_1AduSX2eZvKYlo2C8xD1wGo9 )
    // or
    // Stripe Payment Method ID (ex: pm_0Knbcsyuwrn8hbvSBI82BPrT )
    card_id: {
      type: String,
      default: ''
    },
    // Stripe card fingerprint
    fingerprint: {
      type: String,
      default: ''
    },
    // このカードに紐付けられている本人確認済み住所
    shippings: {
      type: Array,
      default: []
    }
  },

  paypal: {
    // 最後にPayPalのpaymentを作成したときのID (例：PAY-1B56960729604235TKQQIYVY)
    payment_id: {
      type: String
    },
    // Payer ID (例：4G6P88SZAMRDC)
    payer_id: {
      type: String
    },
    // Payments作成時に選択されていたShippings
    shippings: {
      type: Array,
      default: []
    }
  },

  amazon: {
    // Payments作成時に選択されていたShippings
    shippings: {
      type: Array,
      default: []
    }
  },

  // デフォルトの決済方法かどうか。
  // 値は "shop", "subscription"
  is_default_for: {
    type: Array,
    default: []
  },

  // 住所選択のセキュリティチェックに使う
  csrf_token: {
    type: String,
    default: ''
  },

  // P会員の入会ですでに使われている決済方法かどうか
  already_used_for_premium: {
    type: Boolean,
    default: false
  }
});

/**
 * @param {String} service - 'shop' or 'projects' (default value is 'shop')
 * @return {Object} Returns default payment information used by the service passed by the argument
 */
Payment.getCurrent = function(service = 'shop') {
  return Payment.findOne((payment) => {
    return payment.is_default_for.includes(service);
  });
};

/**
 * @param {Object} payment - payment information
 * @return {Boolean} Returns payment method is Paypal
 */
Payment.isPayPal = function(payment) {
  return payment && payment.method === PAYMENT_METHOD.PAYPAL;
};

/**
 * @param {Object} payment - payment information
 * @return {Boolean} Returns payment method is Stripe
 */
Payment.isStripe = function(payment) {
  return payment && payment.method === PAYMENT_METHOD.STRIPE;
};

/**
 * @param {Object} payment - payment information
 * @return {Boolean} Returns payment method is Bypass
 */
Payment.isBypass = function(payment) {
  return payment && payment.method === PAYMENT_METHOD.BYPASS;
};

/*
クレジットカード情報（stripe）
*/
export const Card = new Schema({
  id: {
    type: String,
    default: ''
  },
  object: {
    type: String,
    default: ''
  },
  address_city: {
    type: String,
    default: ''
  },
  address_country: {
    type: String,
    default: ''
  },
  address_line1: {
    type: String,
    default: ''
  },
  address_line1_check: {
    type: String,
    default: ''
  },
  address_line2: {
    type: String,
    default: ''
  },
  address_state: {
    type: String,
    default: ''
  },
  address_zip: {
    type: String,
    default: ''
  },
  address_zip_check: {
    type: String,
    default: ''
  },
  brand: {
    type: String,
    default: ''
  },
  country: {
    type: String,
    default: ''
  },
  customer: {
    type: String,
    default: ''
  },
  cvc_check: {
    type: String,
    default: ''
  },
  dynamic_last4: {
    type: String,
    default: ''
  },
  exp_month: {
    type: String,
    default: ''
  },
  exp_year: {
    type: String,
    default: ''
  },
  fingerprint: {
    type: String,
    default: ''
  },
  funding: {
    type: String,
    default: ''
  },
  last4: {
    type: String,
    default: ''
  },
  metadata: {
    type: Object,
    default: {}
  },
  name: {
    type: String,
    default: ''
  },
  tokenization_method: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  }
});

Payment.PAYMENT_METHOD = PAYMENT_METHOD;

Card.CARD_BRANDS = CARD_BRANDS;

export default {
  Payment,
  Card
};
